<template>
  <div class="stats">
    <NewStatsPanel v-if="$features['display-new-analytics']">
      >
      <ComingSoon slot="empty">
        <template
          v-if="contentOwnershipsCount === 0"
        >{{ $t("Come back to see statistics about your content after you’ve added your content to SpringboardVR.") }}</template>
        <template
          v-else
        >{{ $t("We're collecting data on your content. Check back soon for statistics.") }}</template>
      </ComingSoon>
    </NewStatsPanel>
    <StatsPanel v-else>
      <coming-soon slot="empty">
        <template
          v-if="contentOwnershipsCount === 0"
        >{{ $t("Come back to see statistics about your content after you’ve added your content to SpringboardVR.") }}</template>
        <template
          v-else
        >{{ $t("We're collecting data on your content. Check back soon for statistics.") }}</template>
      </coming-soon>
    </StatsPanel>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ComingSoon from './ComingSoon';
import StatsPanel from './StatsPanel';
import NewStatsPanel from './NewStatsPanel';
import { mapState } from 'vuex';

@Component({
  computed: mapState({
    contentOwnershipsCount: state => state.contentOwnerships.length,
  }),
  components: {
    ComingSoon,
    StatsPanel,
    NewStatsPanel,
  },
})
export default class Stats extends Vue {
  created () {
    this.$store.commit('setTitle', this.$t('Stats'));
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.stats {
  @apply --container;

  padding-top: var(--spacingMd);
  padding-bottom: var(--spacingMd);
}
</style>
